import PubSub from "underpub-js";

var WhatsAppWidget = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-WhatsAppWidget',
	};

	$.extend(true, this.options, options);

};

WhatsAppWidget.prototype.init = function() {

	var self = this;

};

export default WhatsAppWidget;
